import { create } from 'zustand';

import { IUser } from '@/models';

interface AgencyUsersStore {
  agencyUsers: IUser[] | null;
  isLoading: boolean;
  error: Error | null;
  setAgencyUsers: (users: IUser[]) => void;
  clearAgencyUsers: () => void;
}

export const useAgencyUsersStore = create<AgencyUsersStore>((set) => ({
  agencyUsers: null,
  isLoading: false,
  error: null,
  setAgencyUsers: (users: IUser[]) => set({ agencyUsers: users }),
  clearAgencyUsers: () => set({ agencyUsers: null }),
}));

export const selectAgencyUsers = (state: AgencyUsersStore) => state.agencyUsers;
export const selectIsLoading = (state: AgencyUsersStore) => state.isLoading;
export const selectError = (state: AgencyUsersStore) => state.error;
export const selectClearAgencyUsers = (state: AgencyUsersStore) =>
  state.clearAgencyUsers;
